@if (sendingParams) {
  <div class="form-container">
    <clickatell-expansion-panel>
      <ng-container header>
        <mat-panel-title>
          Parameters
        </mat-panel-title>
      </ng-container>
      <ng-container body>
        <ng-container [formGroup]="sendingParams">
          <div class="control-div">
            <div class="control-label-container">
              <label class="control-label"> First Name </label>
            </div>
            <ng-container
              *ngTemplateOutlet="validators; context: { myControlName: 'firstName', myForm: sendingParams}">
            </ng-container>
            <input class="control-input" activeForm [activeForm]="sendingParams" id="firstName"
              [formControlName]="'firstName'"
              placeholder="Enter your first name" style="resize: none"/>
            </div>
            <div class="control-div">
              <div class="control-label-container">
                <label class="control-label"> Last Name </label>
              </div>
              <ng-container
                *ngTemplateOutlet="validators; context: { myControlName: 'lastName', myForm: sendingParams}">
              </ng-container>
              <input class="control-input" activeForm [activeForm]="sendingParams" id="lastName"
                [formControlName]="'lastName'"
                placeholder="Enter your first name" style="resize: none"/>
              </div>
              <div class="control-div">
                <div class="control-label-container">
                  <label class="control-label"> Formatted Name </label>
                </div>
                <ng-container
                  *ngTemplateOutlet="validators; context: { myControlName: 'formattedName', myForm: sendingParams}">
                </ng-container>
                <input class="control-input" activeForm [activeForm]="sendingParams" id="formattedName"
                  [formControlName]="'formattedName'"
                  placeholder="Enter your formatted name" style="resize: none"/>
                </div>
                <div class="control-btn-container btndrop">
                  <contact-dropdown-button (addContact)="addContact($event)" [contactInfo]="contactInfoRawData"></contact-dropdown-button>
                </div>
                <contacts-template [contactInfo]="contactInfo" (delete)="deleteTemplate($event)"></contacts-template>
                <div [ngStyle]="{display:(addNewFieldSet>0) ? 'none': ''}">
                  @if (checkIfAddNewFieldIsTouchedOrDirty()) {
                    <div class="banner-container">
                      <div class="banner-block">
                        <div class="icon"></div>
                        <div class="banner-alignment">
                          <div class="title">Required Fields</div>
                          <div class="content">At least one additional contact field required.</div>
                        </div>
                      </div>
                    </div>
                  } @else {
                    <div class="control-div">
                      <div class="banner-container">
                        <div class="banner-block red">
                          <div class="icon red"></div>
                          <div class="banner-alignment">
                            <div class="title">Required Fields</div>
                            <div class="content red">At least one additional contact field required.</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              </ng-container>
            </ng-container>
          </clickatell-expansion-panel>
          <clickatell-expansion-panel>
            <ng-container header>
              <mat-panel-title>
                Logic
              </mat-panel-title>
            </ng-container>
            <ng-container body>
              <div class="control-div">
                <label class="control-label">
                  <span class="pont-to">Point To</span>
                </label>
                <app-cms class="popover" [type]="'nodeBuild'" [field]="'next'"></app-cms>
                @if (nodeFlowDetails) {
                  <next-selector [canEditFlows]="canEdit.canEditFlows" [selectorType]="'both'"
                    [flowSteps]="nodeFlowDetails.currentFlowSteps" [flows]="nodeFlowDetails.flows"
                    [stepId]="nodeFlowDetails.stepId"
                    [name]="'next'"
                    [form]="sendingParams">
                    >
                  </next-selector>
                }
              </div>
            </ng-container>
          </clickatell-expansion-panel>
        </div>
      }

      <ng-template #validators let-myControlName="myControlName" let-myForm=myForm>
        @if (myForm.controls[myControlName]; as control) {
          @if (control.invalid && (control.dirty || control.touched)) {
            <div class="validationField">
              @for (error of control.errors | keyvalue; track error) {
                <div>
                  <span class="fa fa-exclamation-circle"></span>
                  <span [id]=" myControlName">
                    {{error.value}}
                  </span>
                </div>
              }
            </div>
          }
        }
      </ng-template>

